module.exports = __webpack_public_path__ + "img/axcu.ce234ce1.jpg";